import { Input, Output, EventEmitter } from '@angular/core';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { CompanyManageService } from '../../../service/api/jubili/company-manage.service';
import { CompanyUpdateFeatureModel } from '../../../model/jubili/company-manage/company-update-feature-model';
import { UpdateAccessCompanyModel } from "../../../model/jubili/company-manage/update-access-company.model";
import { pageRoute } from '../../../constant/pageRoute';
@Component({
  selector: 'bo-jubili-edit-feature-modal',
  templateUrl: './jubili-edit-feature-modal.component.html',
  styleUrls: ['./jubili-edit-feature-modal.component.scss']
})
export class JubiliEditFeatureModalComponent implements OnInit {

  private ngbModalRef: NgbModalRef;
  constructor(private modalService: NgbModal,
    private companyManageService: CompanyManageService)
  { }

  @ViewChild("content") content: any;
  companySurrkey: number;
  isQoPhoto: boolean;
  isActiveLocationFeature: boolean;
  isDatawarehouse : boolean;
  isGeoMap : boolean;
  isAccess: boolean;
  isBadge: boolean;
  isHide: number;
  isActiveLocationOffLimit: boolean;
  trueHide: boolean = true;
  falseHide: boolean = false;
  isAccessWebhook: boolean = false;
  @Output() response = new EventEmitter<CompanyUpdateFeatureModel>();
  updateFeatureData : CompanyUpdateFeatureModel = new CompanyUpdateFeatureModel();
  jubSettingFormUrl: string = pageRoute.jubSettingForm;
  ngOnInit() {
    this.updateFeatureData = new CompanyUpdateFeatureModel();
  }

  switchQoPhoto(value: number){
    this.isQoPhoto = !this.isQoPhoto;

  }

  switchAccess(value: number) {
    this.isAccess = !this.isAccess;
  }

  switchBadge(value: number) {
    this.isBadge = !this.isBadge;
  }

  switchHide(value: number) {
    if(Number(this.isHide) == 0) {
      this.isHide = 1;
    } else {
      this.isHide = 0;
    }
  }

  switchActiveLocationOffLimit(value: number) {
    this.isActiveLocationOffLimit = !this.isActiveLocationOffLimit;
  }
  switchLocation(value: number){
    this.isActiveLocationFeature = !this.isActiveLocationFeature;

  }

  switchDatawarehouse(value: number){
    this.isDatawarehouse = !this.isDatawarehouse;

  }

  switchAccessWebhook(value: number) {
    this.isAccessWebhook = !this.isAccessWebhook;
  }

  switchGeoMap(value : number){
    this.isGeoMap = !this.isGeoMap;
  }

  async submit(){
    // await this.updateHideCompany(this.isHide, this.companySurrkey);
    // await this.UpdateAccessCompany(this.companySurrkey, this.isAccess);
    // await this.updateBadgeCompany(+this.isBadge, this.companySurrkey);
    // await this.updateActiveLocationOffLimitCompany(this.isActiveLocationOffLimit, this.companySurrkey);

    this.updateFeatureData.isQoPhoto = +this.isQoPhoto;
    this.updateFeatureData.isActiveLocationFeature = +this.isActiveLocationFeature;
    this.updateFeatureData.isDatawarehouse = +this.isDatawarehouse;
    this.updateFeatureData.isAccess = +this.isAccess;
    this.updateFeatureData.isBadge = +this.isBadge;
    this.updateFeatureData.isHide = this.isHide;
    this.updateFeatureData.isActiveLocationOffLimit = +this.isActiveLocationOffLimit;
    this.updateFeatureData.isGeoMap = +this.isGeoMap;
    this.updateFeatureData.isAccessWebhook = +this.isAccessWebhook;
    this.response.emit(this.updateFeatureData);
    this.hide();
  }

  public show(companySurrkey: number, isQoPhoto: boolean, isActiveLocationFeature: boolean,isDatawarehouse:boolean, isAvaliable: boolean, isBadge: boolean, isHide: number, isActiveLocationOffLimit: boolean, isGeomap: boolean, isAccessWebhook): void {
    this.companySurrkey = companySurrkey;
    this.isQoPhoto = isQoPhoto;
    this.isActiveLocationFeature = isActiveLocationFeature;
    this.isDatawarehouse = isDatawarehouse;
    this.updateFeatureData.companySurrkey = this.companySurrkey;
    this.updateFeatureData.isQoPhoto = +this.isQoPhoto;
    this.updateFeatureData.isDatawarehouse = +this.isDatawarehouse;
    this.updateFeatureData.isActiveLocationFeature = +this.isActiveLocationFeature;
    this.isAccess = isAvaliable;
    this.updateFeatureData.isAccess =+ this.isAccess;
    this.isBadge = isBadge;
    this.updateFeatureData.isBadge =+ this.isBadge;
    this.isHide = isHide;
    this.updateFeatureData.isHide = this.isHide;
    this.isActiveLocationOffLimit = isActiveLocationOffLimit;
    this.isGeoMap = isGeomap;
    this.isAccessWebhook = isAccessWebhook;
    this.ngbModalRef = this.modalService.open(this.content, { centered: true });
  }

  public hide(): void {
    this.ngbModalRef.close();
  }

  UpdateAccessCompany(companySurrKey: number, status: boolean): void {
    const data = new UpdateAccessCompanyModel();
    data.companySurrKey = companySurrKey;
    data.status = status;
    this.companyManageService.updateAccessCompany(data)
    .subscribe(() => {

    },         err => {
  });
  }
  // set hide company
  updateHideCompany(hidecompany: number, companySurr: number): void {
    this.companyManageService.updateHideCompanyBackOffice(hidecompany, companySurr)
    .subscribe(
        Response => {
            console.log(Response);
        }
    );
  }

  // set badge company
  updateBadgeCompany(badgecompany: number, companySurr: number): void {
    this.companyManageService.updateBadgeCompanyBackOffice(badgecompany, companySurr)
    .subscribe(
        Response => {
            console.log(Response);
        }
    );
  }

  updateActiveLocationOffLimitCompany(isActiveLocationOffLimit: boolean, companySurr: number): void {
    this.companyManageService.updateActiveLocationOffLimitBackOffice(isActiveLocationOffLimit, companySurr)
    .subscribe(
        Response => {
            console.log(Response);
        }
    );
  }

  updateGeomap(isGeoMap: boolean, companySurr: number): void {
    this.companyManageService.updateGeomap(isGeoMap, companySurr)
    .subscribe(
        Response => {
            console.log(Response);
        }
    );
  }

}
